import React, { Fragment, useContext, useState, useEffect } from "react";
/// React router dom
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import jharkhandlogo1 from "../../../images/jharkhandlogo1.png";
import ukLogo from "../../../images/uklogo.png";
import "./style.css";
import { useSelector } from "react-redux";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const NavHader = () => {
  const isSidebarOpen = useSelector((state) => state.ui.isSidebarOpen);
  const loginDetails = localStorage.getItem("login_Details");
  const loginFullDetails = JSON.parse(loginDetails);
  const [toggle, setToggle] = useState(false);
  const { navigationHader, background } = useContext(ThemeContext);
  const [redirectTo, setRedirectTo] = useState("/");


  useEffect(() => {
    const userType = localStorage.getItem("user_type");
    const loginDetails = JSON.parse(localStorage.getItem("login_Details"));

    if (loginDetails?.user?.user_level == 6) {
      setRedirectTo("/venue-manager");
    } else if (userType === "user") {
      setRedirectTo(process.env.REACT_APP_UK_WEBSITE_URL);
    } else {
      setRedirectTo("/Organization");
    }
  }, []);


  return (
    <div className="nav-header border-bottom  navbar-height border-bottom-left-round white">
      <Link to={redirectTo} className="brand-logo py-1">
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <div className="d-flex">
              <div>
                <img src={ukLogo} alt="logo" />
              </div>
              
            </div>

            {/* <div className="brand-title">
              <span className="brand-sub-title">
                {loginFullDetails?.user?.name}
              </span>
            </div> */}
          </Fragment>
        ) : (
          <Fragment>
            <div className="d-flex py-1">
               {isSidebarOpen? ( <>
               <img
                  src={jharkhandlogo1}
                  alt="logo"
                  className="logo_img_small"
                /><img
                  src={ukLogo}
                  alt="logo"
                  className="logo_img large_Width_logo"
                /></>):(
                <img
                  src={jharkhandlogo1}
                  alt="logo"
                  className="logo_img_small_fixed"
                />)}
            </div>
            {/* <div className="brand-title mb-4">
              <span className="brand-sub-title">
                {loginFullDetails?.user?.name}
              </span>
            </div> */}
          </Fragment>
        )}
      </Link>

      
    </div>
  );
};

export default NavHader;
